// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IServiceUpdateRequest
 */
export interface IServiceUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof IServiceUpdateRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IServiceUpdateRequest
     */
    category_type?: IServiceUpdateRequestCategoryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IServiceUpdateRequest
     */
    service_type?: IServiceUpdateRequestServiceTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IServiceUpdateRequestCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}
/**
* @export
* @enum {string}
*/
export enum IServiceUpdateRequestServiceTypeEnum {
    CARD = 'CARD',
    MANUAL_CLAIM = 'MANUAL_CLAIM',
    HEALTH_PLAN = 'HEALTH_PLAN',
    HIDDEN = 'HIDDEN'
}


/**
 * Check if a given object implements the IServiceUpdateRequest interface.
 */
export function instanceOfIServiceUpdateRequest(value: object): value is IServiceUpdateRequest {
    return true;
}

export function IServiceUpdateRequestFromJSON(json: any): IServiceUpdateRequest {
    return IServiceUpdateRequestFromJSONTyped(json, false);
}

export function IServiceUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IServiceUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'service_type': json['service_type'] == null ? undefined : json['service_type'],
    };
}

export function IServiceUpdateRequestToJSON(json: any): IServiceUpdateRequest {
    return IServiceUpdateRequestToJSONTyped(json, false);
}

export function IServiceUpdateRequestToJSONTyped(value?: IServiceUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'category_type': value['category_type'],
        'service_type': value['service_type'],
    };
}

